import * as React from 'react';

import './TextExtenderStyle.less';

export interface ITextExtenderProps {
  link?: string;
  text: string;
}

export interface ITextExtenderState {
  onHover: boolean;
}

export default class TextExtender extends React.Component<ITextExtenderProps> {
  public static defaultProps: Partial<ITextExtenderProps> = {
    text: '',
  };

  public state: ITextExtenderState = {
    onHover: false,
  };

  public setHoverTrue = () => {
    this.setState({ onHover: true });
  };

  public setHoverFalse = () => {
    this.setState({ onHover: false });
  };

  public render() {
    const { link, text } = this.props;
    const { onHover } = this.state;
    const emailLink = link ? <a href={link}>{text}</a> : text;

    return (
      <div
        className="text-extender"
        onMouseEnter={this.setHoverTrue}
        onMouseLeave={this.setHoverFalse}
      >
        <div className="text-extender-text">{emailLink}</div>
        {onHover && <div className="text-extender-box">{emailLink}</div>}
      </div>
    );
  }
}
